import type {
  AugmentedMember,
  ProcessedGroupChannel,
  SendBirdContact,
  SendBirdContactsMap,
} from "../types";

export function processSendBirdMembers(
  map: SendBirdContactsMap,
  channel: ProcessedGroupChannel,
): SendBirdContactsMap {
  Object.entries<AugmentedMember>(channel.otherMembersMap).forEach(([userId, member]) => {
    // Mutate in place rather than spreading to preserve SendBird prototype methods on the member object
    const contact = member as unknown as SendBirdContact;
    const metaData = member.metaData as Record<string, string>;

    contact.group = metaData["group"];
    contact.lastMessage = channel.lastMessage;
    // If a member is assigned a prescriber, but the prescriber has not messaged the member previously,
    // we should not display the prescriber name here
    contact.shouldShow = Boolean(channel.lastMessage) || metaData["group"] !== "provider:prescribe";
    contact.unreadMessageCount = member.unreadMessageCount;

    map[userId] = contact;
  });

  return map;
}
